import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Modal, Button } from '@salesforce/design-system-react';

import './UnsavedChangesModal.scss';

class UnsavedChangesModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = this.props.modalName;
  }

  closeModal() {
    this.props.actions.closeModal(this.modalName);
  }

  onClose(tabIndex) {
    if (tabIndex >= 0) {
      this.closeModal();
      this.props.setSelectedTabIndex(tabIndex);
      this.props.cancelRules();
    } else {
      this.props.cancelRulesAndGoBack();
      this.closeModal();
    }
  }

  renderBody(changedRulesList) {
    const { formatMessage } = this.props.intl;
    return (
      <div className="slds-p-around_medium slds-modal__content font">
        {formatMessage(
          {
            id: 'common.unsavedChangesModal.bodyMessage'
          },
          { changedRulesList: changedRulesList }
        )}
      </div>
    );
  }

  renderFooter(tabIndex) {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <Button
          label={formatMessage({
            id: 'common.actions.cancel'
          })}
          onClick={this.closeModal.bind(this)}
        />
        <Button
          label={formatMessage({
            id: 'common.unsavedChangesModal.title'
          })}
          variant="brand"
          onClick={this.onClose.bind(this, tabIndex)}
        />
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen =
      this.props.modals[this.modalName] &&
      this.props.modals[this.modalName].isOpen;
    const dirtyTabs = this.props.modals[this.modalName]?.data
      ?.unsavedChangesMessage
      ? this.props.modals[this.modalName]?.data?.unsavedChangesMessage
      : this.props.modals[this.modalName]?.data;
    const tabIndex = this.props.modals[this.modalName]?.data?.index;
    return (
      <Modal
        heading={formatMessage({
          id: 'common.unsavedChangesModal.title'
        })}
        isOpen={isOpen || false}
        dismissOnClickOutside={false}
        onRequestClose={this.closeModal.bind(this)}
        footer={this.renderFooter(tabIndex)}
      >
        {this.renderBody(dirtyTabs)}
      </Modal>
    );
  }
}

export default injectIntl(UnsavedChangesModal);
